import { render } from "./WorkBench.vue?vue&type=template&id=0c00c765&scoped=true"
import script from "./WorkBench.vue?vue&type=script&lang=js"
export * from "./WorkBench.vue?vue&type=script&lang=js"

import "./WorkBench.vue?vue&type=style&index=0&id=0c00c765&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c00c765"]])

export default __exports__